import { useDispatch, useSelector } from "react-redux";
import {
  setRaceTypeFilters,
  setRegionFilters,
  clearFilters
} from "../redux/actions/raceTracksFilter";
import {
  getRaceTypesFilter,
  getRegionsFilter,
  getTracksFilterMsg
} from "../redux/selectors";
import { mergeValues } from "../utils/races";
import {
  isApplyingFilter,
  sendTracksFilterAnalyticEvt
} from "../utils/analytics";

const useRaceTracksFilter = () => {
  const dispatch = useDispatch();
  const raceTypesFilter = useSelector(getRaceTypesFilter);
  const regionsFilter = useSelector(getRegionsFilter);
  const tracksFilterMsg = useSelector(getTracksFilterMsg);

  const handleRaceTypeChange = (raceType: string, currentTab: string) => {
    const newRaceTypeFilters = mergeValues(raceTypesFilter, raceType);
    const shouldSendAnalyticEvt = isApplyingFilter(
      newRaceTypeFilters,
      raceType
    );
    dispatch(setRaceTypeFilters(newRaceTypeFilters));
    if (shouldSendAnalyticEvt) {
      sendTracksFilterAnalyticEvt({
        filterName: "race_type",
        filterValue: raceType,
        activeTab: currentTab
      });
    }
  };

  const handleRegionChange = (region: string, currentTab: string) => {
    const newRegionFilters = mergeValues(regionsFilter, region);
    const shouldSendAnalyticEvt = isApplyingFilter(newRegionFilters, region);
    dispatch(setRegionFilters(newRegionFilters));
    if (shouldSendAnalyticEvt) {
      sendTracksFilterAnalyticEvt({
        filterName: "region",
        filterValue: region,
        activeTab: currentTab
      });
    }
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  return {
    tracksFilterMsg,
    raceTypesFilter,
    regionsFilter,
    handleRaceTypeChange,
    handleRegionChange,
    handleClearFilters
  };
};

export default useRaceTracksFilter;
